import React, {useState, useEffect, useCallback, memo, Fragment, useContext, useRef } from 'react';
import { StoreContext } from '../Store/StoreProvider';
import { 
         Button,
         Card,
         Dialog,
         DialogContent,
         DialogTitle,
         Grid,
         IconButton,
         Paper,
         Table,
         TableBody,
         TableCell,
         TableContainer,
         TableHead,
         TableRow,
         TextField,
         Tooltip,
         Chip,
         Divider,
         CardHeader,
         CardMedia
        } from '@material-ui/core';
import { 
            AlternateEmail as AlternateEmailIcon,
            Block as BlockIcon,
            CheckCircle as CheckCircleIcon,
            DeleteForever as DeleteForeverIcon,
            Dns as DnsIcon,
            GpsFixed as GpsFixedIcon,
            MonetizationOn as MonetizationOnIcon,
            Place as PlaceIcon,
            Phone as PhoneIcon,
            PhoneIphone as PhoneIphoneIcon,
            Sync as SyncIcon,
            Whatshot as WhatshotIcon,
            AddCircle as AddCircleIcon,
            CloudUpload as CloudUploadIcon,
            Done as DoneIcon,
            Help as HelpIcon,
            PhotoCamera as PhotoIcon,
        } from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { makeStyles } from '@material-ui/core/styles';
import { useAuth } from "../Auth";
import PdfInstalacionRadio from './PdfInstalacionRadio';
import PdfInstalacionFibra from './PdfInstalacionFibra';
import Swal from 'sweetalert2';
import Viewer from 'react-viewer';
import { v4 as uuidv4 } from 'uuid';
import { 
    Button as ButtonAntd,
    Modal as ModalAntd,
    Popconfirm, 
    Switch as SwitchAntd, 
    Tooltip as TooltipAntd, 
} from 'antd';
import { 
         ApiOutlined as ApiOutlinedIcon,
         ClusterOutlined as ClusterOutlinedIcon,
         CopyOutlined as ContentCopyIcon, 
         DeleteOutlined as DeleteOutlinedIcon,
         EyeOutlined as EyeOutlinedIcon,
         EyeInvisibleOutlined as EyeInvisibleOutlinedIcon,
         FilePdfOutlined as FilePdfOutlinedIcon,
         InteractionOutlined as InteractionOutlinedIcon,
         LoadingOutlined as LoadingOutlinedIcon,
         PoweroffOutlined as PoweroffOutlinedIcon,
         RadiusSettingOutlined as RadiusSettingOutlinedIcon,        
         SecurityScanOutlined as SecurityScanOutlinedIcon,
         SettingOutlined as SettingOutlinedIcon,
         SyncOutlined as SyncOutlinedIcon,
         VerifiedOutlined as VerifiedOutlinedIcon,
         TeamOutlined as TeamOutlinedIcon,
         WifiOutlined as WifiOutlinedIcon
        } from '@ant-design/icons';
import copy from "copy-to-clipboard";  
import useDialog from '../HooksPerson/useDialog';
//import useMapbox from '../HooksPerson/useMapbox'
import mapboxgl from 'mapbox-gl';

mapboxgl.accessToken = 'pk.eyJ1Ijoic2pjYXN0aWxsb2ciLCJhIjoiY2wxMWVkaDJuMnVhbzNqcW9iM3F4OGt4ZSJ9.hrEONHeoraHrkJTV4ervWQ';


const useStyles = makeStyles((theme)=>({
    rootCI: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        marginTop:-1,
        height:41
      },
      input: {
        marginLeft: theme.spacing(1),
        flex: 1,
      },
      iconButton: {
        padding: 10,
      },
      backdrop: {
        zIndex: theme.zIndex.drawer + 1, 
        color: '#fff',
      },
      headerButton:{
        //overflow:'hidden', 
        background:'#fff', 
        display:'flex', 
        justifyContent:'center',
        padding:5, 
        position:'sticky', 
        top:0, 
        zIndex:2, 

      },
      inputUp:{ 
        borderBottom:' 4px solid #0E3B5F',
        borderRight:' 4px solid #0E3B5F',
        borderTop:' 1px solid #0E3B5F',
        borderLeft: '1px solid #0E3B5F',
        padding: 10,
        color:'#0E3B5F',
        textTransform:'uppercase',
        fontWeight:'bolder',
        cursor: 'pointer',
        borderRadius:'8px',
        width:'100%'
        },
        media: {
            height: 200,
            // border:'1px solid red',
            paddingTop: '56.25%', // 16:9
        },
        containerUpload:{
            maxHeight:450,
            height:450
        },
        rootCard:{
            height:350
        }
}));

function capitalize(word) { return word[0].toUpperCase() + word.slice(1); };



function YounetClientAdd(){
    const classes = useStyles();
    const [ { zonas, isReadyInfo, clientes, stock }, dispatch ] = useContext(StoreContext);
    const { authTokens, openDrawer } = useAuth(); 
    const [ DatosF, setDatosF] = useState({Registro:'', Modificacion: '', Nombres:'', Servicios:[], CI:'', Zona:''});
    const [ correos, setCorreos ]= useState([]);
    const [ celulares, setCelulares ]= useState([]);
    const [ convencionales, setConvencionales ]= useState([]);
    const [ servicios, setServicios ] = useState([]);             
    // const [ isFibra, setFibra ] = useState(false);        
    const [ elementDisable, setElementDisable ] = useState(true);       
    const [ dataClientes, setDataClientes ] = useState([]);
    const [ showAutocomplete, setShowAutocomplete ] = useState(true);
    const [ dataZona, setDataZona ] = useState(zonas? zonas :[]);
    const [ zonaSelected, setZonaSelected ] = useState('');
    const [ zonaSelectedObject, setZonaSelectedObject ] = useState({});
    const [ isSelectedZona, setSelectedZona ] = useState(false);
    const [ getArrAp, setArrAp ] = useState([]);
    const [ getUpdateZone, setUpdateZone ] = useState(false);
    const [ getReadyInfo, setReadyInfo ] = useState(false);


    useEffect(
        ()=>{  
            if(isReadyInfo){ 
                if(getReadyInfo === false){
                    authTokens.Type === 'ADMINISTRADOR' ? 
                    (()=>{
                        setDataZona(zonas);
                        setReadyInfo(true);
                    })()   : (()=>{   
                        const ZonasArr = authTokens.Zonas.map(valZon=> valZon.Zona);
                        const arrFilZona = zonas.filter(value=> ZonasArr.includes(value.Zona.toString()));
                        setDataZona(arrFilZona); 
                        setReadyInfo(true);
                    })()
                }
            }
        },[isReadyInfo] // eslint-disable-line react-hooks/exhaustive-deps
    );

    useEffect(()=>{
        if(getUpdateZone){
            const handleForZona = async () =>{ 
                setUpdateZone(false);
                // zonaSelectedObject.isFibraOptica && setFibra(true);
                const arrClientes = [];
                const arrIdfM = [];
                for(const x in clientes){
                    const objeto = {...clientes[x]};
                    const arrFiltrado = objeto.Servicios.filter(value=>value.ZonaService.toString() === zonaSelected.toString());
                    for(const y in objeto.Servicios){ arrIdfM.push(objeto.Servicios[y].idForMikrotik) };
                    if(arrFiltrado.length > 0){
                        objeto.Servicios = arrFiltrado;
                        arrClientes.push(objeto);
                    }else{
                        if(clientes[x].Servicios.length === 0)arrClientes.push(objeto);
                    }
                };
                const getAp = await fetch('/api/equipos');
                const arr_Ap = await getAp.json();
                //const getAp1 = await fetch('/api/users');
                // const arr_Ap1 = await getAp1.json();
                //const getAp2 = await fetch('/api/Tecnologias');
                //const arr_Ap2 = await getAp2.json();
                const arrfillZona = arr_Ap.filter(el=>el.Zona === zonaSelected.toString());
                setArrAp(arrfillZona);
                setDataClientes(arrClientes);
                
            };

            handleForZona();
            
        }
    },[getUpdateZone]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleSelectClient = (e, value, reason)=>{
        if(reason === 'select-option'){
            if(showAutocomplete){
                const inf = dataClientes.filter(el=>el.Nombres === value)[0];
                setDatosF(inf);
                setElementDisable(false); 
                setCelulares(inf.Celular);
                setConvencionales(inf.Convencional);
                setCorreos(inf.Correo);
                if(inf.Servicios.length > 0){ 
                    const arrFiltrado = inf.Servicios.filter(el=>el.ZonaService.toString() === zonaSelected);
                    setServicios(arrFiltrado);
                }
            }else{
                const inf = dataClientes.filter(el=>el.CI === value)[0];
                setDatosF(inf);
                setElementDisable(false); 
                setCelulares(inf.Celular);
                setConvencionales(inf.Convencional);
                setCorreos(inf.Correo);
                if(inf.Servicios.length > 0){ 
                    const arrFiltrado = inf.Servicios.filter(el=>el.ZonaService.toString() === zonaSelected);
                    setServicios(arrFiltrado);
                }
            }
            
        }else{
            setDatosF({...DatosF,
                Nombres:'',
                CI:'',
                idCliente:'',
                Correo:'',
                Celular:'',
                idForMikrotik:'',
                idServicio:'',
            })
            setCelulares([]);
            setConvencionales([]);
            setCorreos([]);
            setServicios([]);
        }
    };
  
    const CorreosEl = correos.map((value, index)=>(
        <ElementCorreo 
            index={index} 
            key={`Correo-${index}`} 
            data={value}
            total={correos.length} 
            disabledEl={elementDisable}
        />
    ));

    const CelularesEl = celulares.map((value, index)=>(
        <ElementCelular 
            index={index} 
            key={`celular_${index}`}
            data={value}  
            total={celulares.length} 
            disabledEl={elementDisable}
        />
    ));

    const ConvencionalesEl = convencionales.map((value, index)=>(
        <ElementConvencional 
            index={index} 
            key={`Convencional_${index}`} 
            data={value} 
            total={convencionales.length} 
            disabledEl={elementDisable}
        />
    ));

    const handleClearZona = ()=>{
        setElementDisable(true);
        setServicios([]);
        setCorreos([]);
        setConvencionales([]);
        setCelulares([]);
        setDatosF({Registro:'', Modificacion: '', Nombres:'', Servicios:[], CI:''});
        setShowAutocomplete(true);
        setZonaSelected('');
        setZonaSelectedObject({});
        setSelectedZona(false);
        setArrAp([]);
        setDataClientes([]);
        setUpdateZone(false);
    };

    const handleSelectZona = (valZ)=>{
        setZonaSelected(valZ);
        const arrFil =  (dataZona.filter(value=> value.Zona.toString() === valZ.toString()))[0];
        setZonaSelectedObject(arrFil);
        setSelectedZona(true);
        setUpdateZone(true);
    };

    const ServiciosEls = servicios.map((valueServicios, indexServ)=>( 
            <Fragment key={`Servicio_${indexServ}`}>
                {
                    valueServicios.TipoServicio === 'Fibra Optica' ? 
                    <ElementServiciosFibra 
                        dispatch={dispatch}
                        index={indexServ} 
                        zonaSelected={zonaSelectedObject} 
                        data={valueServicios} 
                        dataCliente={DatosF}
                        authTokens={authTokens}                         
                        openDrawer={openDrawer}                    
                        classes={classes}
                        stock={stock}
                    /> : 
                    <ElementServiciosRadio 
                        dispatch={dispatch}
                        index={indexServ} 
                        zonaSelected={zonaSelectedObject} 
                        data={valueServicios} 
                        dataCliente={DatosF}
                        authTokens={authTokens} 
                        openDrawer={openDrawer}
                        getArrAp={getArrAp}
                        classes={classes}

                    />
                } 
            </Fragment>
    ));

    const handleByNombres = (checked)=>{ setShowAutocomplete(checked); };

    return(
            <Grid container justifyContent='center' alignItems='flex-start' style={{padding:5, width:'99%', height:'90vh', overflowY:'auto'}} spacing={1}>
                    <Grid item lg={7}  md={8} xs={12} className={classes.headerButton}>
                        <Paper style={{width:'100%', padding:10}} elevation={3}>
                            <Grid container spacing={2} justifyContent='center'>
                                <Grid item md={5} sm={5} xs={10}>
                                    <Autocomplete
                                        id="Zona"
                                        options={dataZona.map(value=>value.Zona)}
                                        value={zonaSelected || ''}                           
                                        renderInput={(params) => <TextField {...params} label="Zona" variant="outlined" size='small' fullWidth color='primary'/>}
                                        onChange={(e,value, reason)=>{
                                            if(reason ===  'clear'){
                                                handleClearZona()
                                            }else{
                                                handleSelectZona(value);
                                            }
                                        }}  
                                    />
                                </Grid>
                                <Grid item xs={2}  style={{paddingTop:15}}>
                                    <TooltipAntd title="CI O NOMBRES" color='BLUE' >
                                        <SwitchAntd disabled={!isSelectedZona} checkedChildren="ON" unCheckedChildren="OFF" checked={showAutocomplete} onChange={handleByNombres} />
                                    </TooltipAntd>  
                                </Grid>
                                <Grid item md={6} xs={12} >
                                    <Autocomplete
                                        id="Cliente"
                                        options={dataClientes.map(value=> showAutocomplete ? value.Nombres : value.CI)}
                                        value={ showAutocomplete ? DatosF.Nombres : DatosF.CI || ''}                              
                                        renderInput={(params) => <TextField {...params} label={ showAutocomplete ? 'Nombres' : 'CI'} variant="outlined" size='small' fullWidth color='primary'/>}
                                        onChange={handleSelectClient}  
                                        disabled={!isSelectedZona}
                                    />                        
                                </Grid>
                                {
                                    showAutocomplete ?
                                    <Grid item md={6} xs={12} >
                                        <TextField 
                                            id='CI'
                                            fullWidth
                                            label='CI'
                                            value={DatosF.CI || ''}
                                            variant='outlined'
                                            size='small'
                                            disabled={!isSelectedZona}
                                        />
                                    </Grid>:
                                    <Grid item md={6} xs={12} >
                                        <TextField 
                                            id='Cliente'
                                            fullWidth
                                            label='Nombres'
                                            value={DatosF.Nombres || ''}
                                            variant='outlined'
                                            size='small'
                                            disabled={!isSelectedZona}
                                        />
                                    </Grid>
                                }
                            </Grid>
                        </Paper>
                    </Grid>         
                    <Grid item lg={7}  md={8} xs={12}>  
                        <Grid container spacing={1} justifyContent='center' style={{padding:10}}>
                            { CorreosEl }  
                            { CelularesEl } 
                            { ConvencionalesEl } 
                            {  ServiciosEls }                         
                        </Grid>
                    </Grid>
       
            </Grid>
    );
};

const ElementCorreo = memo(({data})=>( 
    <Grid item md={4} sm={12} xs={12} style={{display:'flex', flexDirection:'row'}}>
        <TextField 
            id={data.id}
            fullWidth
            label='Correo'
            type='Email'
            value={data.correo || ''}
            InputProps={{
                startAdornment: <AlternateEmailIcon color='primary'/>
            }}
            variant='outlined'
            size='small'
        />
    </Grid>
    
));

const ElementCelular = memo(({data})=>( 
    <Grid item md={4} sm={12} xs={12} style={{display:'flex', flexDirection:'row'}}>
        <TextField 
            id={data.id}
            fullWidth
            label='Celular'
            value={data.celular || ''}
            InputProps={{
                startAdornment: <PhoneIphoneIcon color='primary'/>
            }}
            variant='outlined'
            size='small'
            type='Number'
        />
    </Grid>   

));

const ElementConvencional = memo(({data})=>( 
        <Grid item md={4} sm={12} xs={12} style={{display:'flex', flexDirection:'row'}}>
            <TextField 
                id={data.id}
                fullWidth
                label='Convencional'
                value={data.convencional || ''}
                InputProps={{
                    startAdornment: <PhoneIcon color='primary'/>
                }}
                variant='outlined'
                size='small'
                type='Number'
            />
        </Grid>   
    
));

const ElementServiciosFibra = memo((props)=>{
    const { 
        classes, data, index, 
        zonaSelected, 
        dataCliente, 
    } = props;
    const [ DatosD, setDatosD] = useState({
        Instalacion:'',
        AddressIp:'',
        Plan:'',
        ValorInstalacion:'',
        idForMikrotik:'',
        ZonaService:zonaSelected.Zona,
        CorteAutomatico:true,
        TipoPagoBoolean:true,
        StatusIns:false,
        Red:'',
        Mascara:'',
        Status:'',
        UserMk:'telecomadmin',
        PassMk:'admintelecom',
        IVA:false,
        SN:'',
        DiaNotificacion:1,
        DiasCorte:4,
        MacOnu:'',
        MacRouter:''
    });
    const [ isReadyPdf, setReadyPdf ] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [ openPhoto, setOpenPhoto ] = useState(false);
    const [ getArrPhotos, setArrPhotos ] = useState([]);
    // const [ isOnuBridge, setOnuBridge ] = useState(false);
    const [ isSearchingOnu, setSearchingOnu ] = useState(false);
    const [ isSearchingPPOE, setSearchingPPOE ] = useState(false);
    const [ getSearchingOptic, setSearchingOptic ] = useState(false);
    const [ getShowWifiInfo, setShowWifiInfo ] = useState(false);
    const [ getShowWifiAssociate, setShowWifiAssociate ] = useState(false);
    const [ openConfWifi , handleOpenConfWifi, handleCloseConfWifi ] = useDialog();
    const [ getNameWifi, setNameWifi ] = useState('');
    const [ isOnWifi, setOnWifi ] = useState(false);
    const [ isOffWifi, setOffWifi ] = useState(false);
    const [ isHiddenWifi, setHiddenWifi ] = useState(false);
    const [ isNoHiddenWifi, setNoHiddenWifi ] = useState(false);
    const [ isChangeName, setNameChange ] = useState(false);
    const [ isRebootOnt, setRebootOnt ] = useState(false);
    const mapDiv = useRef();
    const mapa = useRef();
    //const  { isChange, dataMarked, setRef }  = useMapbox( {lng:data.Coordenadas?.split(',')[1], lat: data.Coordenadas?.split(',')[0], zoom:16.80, id:data._id})


    useEffect(()=>{
        setDatosD(data); 
        setArrPhotos(data.FotosReferencia ? data.FotosReferencia.length > 0 ? data.FotosReferencia : [] : []);
        var map = new mapboxgl.Map({
            container: mapDiv.current,
            style: 'mapbox://styles/mapbox/satellite-v9',
            center: [ 
                data.Coordenadas === '' ? '-79.93395424851998' : 
                data.Coordenadas === undefined ? '-79.93395424851998' : data.Coordenadas.split(',')[1], 
                data.Coordenadas === '' ? '-2.201567808901885' : 
                data.Coordenadas === undefined ? '-2.201567808901885' : data.Coordenadas.split(',')[0] ] ,
            zoom: 16.80
        });

        const marker = new mapboxgl.Marker();
            marker.id = data._id;
            marker
                .setLngLat(
                    [ 
                        data.Coordenadas === '' ? '-79.93395424851998' : 
                        data.Coordenadas === undefined ? '-79.93395424851998' : data.Coordenadas.split(',')[1], 
                        data.Coordenadas === '' ? '-2.201567808901885' : 
                        data.Coordenadas === undefined ? '-2.201567808901885' : data.Coordenadas.split(',')[0] ]
                )
                .addTo( map )
                .setDraggable(true)

            marker.on('dragend', ({target})=>{
                handleUpdateCoor(target._lngLat);
            })

        mapa.current = map;
    },[]);// eslint-disable-line react-hooks/exhaustive-deps


    const handleCreatePdf = ()=>{setReadyPdf(true);};

    const handleClickPdf = useCallback(()=>{
        setTimeout(()=>{
            setReadyPdf(false);
        },[2000]);
    },[]);

    const handleOpenPhoto = ()=>{ setOpenPhoto(true) };

    const handleClosePhoto = ()=>{ setOpenPhoto(false) };

    const handleUpdatePhoto = useCallback((info)=>{
        setArrPhotos(info);
    },[]);

    const handleDeletePhoto = useCallback((info)=>{
        const arr = [...getArrPhotos];
        const arrNew = arr.filter(el=>el.id !== info.id);
        setArrPhotos(arrNew);
    },[getArrPhotos]);

    const handleAddPhoto = ()=>{
        if(data.idForMikrotik === ''){
            Swal.fire({
                title:'ERROR',
                icon:'error',
                text:'Primero debe asignar un idForMikrotik',
                width:600,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonColor:'#005596',
                confirmButtonText:'OK',
                toast:true
            })
        }else{ 
            const arr = [...getArrPhotos];
            const objeto = {};
            objeto.src = '';
            objeto.id = `photo_${uuidv4()}`;
            objeto.idForMikrotik = data.idForMikrotik;
            arr.push(objeto);
            setArrPhotos(arr);
        }
    };

    const handleCoordenadas = ()=>{
        var options = {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
        };

        function success(pos) {
            var crd = pos.coords;    
            //setCoordenadas({Latitud:crd.latitude, Longitud:crd.longitude});  
            setDatosD({...DatosD, Coordenadas:`${crd.latitude}, ${crd.longitude}`});  
            const objeto = {idCliente:dataCliente._id, idServicio:data._id, Coordenadas:`${crd.latitude}, ${crd.longitude}`}
            fetch('/api/clientes/serviciosCoordenadas',{
                method:'PUT',
                body: JSON.stringify(objeto),
                headers:{
                    'Content-Type': 'application/json'
                }
            }) 
            .then(response=> response.json())
            .then(result =>{
                if(result.message){
                    enqueueSnackbar(result.message, {variant:'success'});
                    var map = new mapboxgl.Map({
                        container: mapDiv.current,
                        style: 'mapbox://styles/mapbox/satellite-v9',
                        center: [ crd.longitude, crd.latitude ] ,
                        zoom: 16.80
                    });
            
                    const marker = new mapboxgl.Marker();
                        marker.id = data._id;
                        marker
                            .setLngLat(
                                [ crd.longitude, crd.latitude ]
                            )
                            .addTo( map )
                            .setDraggable(true)

                        marker.on('dragend', ({target})=>{
                            handleUpdateCoor(target._lngLat);
                        })
                    mapa.current = map;
                }else{
                    enqueueSnackbar(result.status, {variant:'error'});
                }
            })
        };
          
        function error(err) {
            console.warn('ERROR(' + err.code + '): ' + err.message);
        };

        navigator.geolocation.getCurrentPosition(success, error, options);
    };

    const handleUpdateCoor = (dataMarked)=>{
        setDatosD({...DatosD, Coordenadas:`${dataMarked.lat.toString()}, ${dataMarked.lng.toString()}`});  
        const objeto = {idCliente:dataCliente._id, idServicio:data._id, Coordenadas:`${dataMarked.lat.toString()}, ${dataMarked.lng.toString()}`}
        fetch('/api/clientes/serviciosCoordenadas',{
            method:'PUT',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                enqueueSnackbar(result.message, {variant:'success'});
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
            }
        })
    };

    const copyToClipBoardUser = ()=>{  
        copy(data.idForMikrotik) 
        enqueueSnackbar('Copiado', {variant:'success'});
    }

    const copyToClipBoardUserP = ()=>{  
        copy(data.UserPPOE) 
        enqueueSnackbar('Copiado', {variant:'success'});
    }

    const copyToClipBoardPass = ()=>{  
        copy(data.PassPPOE) 
        enqueueSnackbar('Copiado', {variant:'success'});
    }

    const handleSearchOnu = ()=>{
        setSearchingOnu(true);
        const objeto = {};
            objeto.SN = data.SN;
            objeto.OLTIP = zonaSelected.OLTIP;
            objeto.OLTPORT = zonaSelected.OLTPORT;
            objeto.Usuario = zonaSelected.Usuario;
            objeto.Password = zonaSelected.Password;
        fetch('/api/SearchOnu',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            try{
                const dataSn = result.split('sn');
                if(dataSn.length > 0){
                    const infoSn = dataSn[1].toString().split('-')[0];
                    Swal.fire({
                        title:infoSn,
                        icon:'success',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonColor:'#005596',
                        toast:true,
                    }); 
                    setTimeout(()=>{
                        setSearchingOnu(false);
                    },500)
                }else{
                    Swal.fire({
                        title:'NO ESTA REGISTRADA ESTA ONU',
                        icon:'error',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonColor:'#005596',
                        toast:true,
                    })
                    setTimeout(()=>{
                        setSearchingOnu(false);
                    },500)
                }
            }catch(err){
                Swal.fire({
                    title:'NO ESTA REGISTRADA ESTA ONU',
                    icon:'error',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                })
                    setTimeout(()=>{
                        setSearchingOnu(false);
                    },500)
            }
            
        });
    };

    const handleSearchPPOE = ()=>{
        setSearchingPPOE(true);
        const objeto = {};
            objeto.idForMikrotik = data.idForMikrotik;
            objeto.InfoZona = {...zonaSelected};
        fetch('/api/SearchActivePPOE',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                Swal.fire({
                    title:result.message,
                    icon:'success',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                });
                setTimeout(()=>{
                    setSearchingPPOE(false);
                },500)
            }else{
                Swal.fire({
                    title:result.status,
                    icon:'error',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                })
                setTimeout(()=>{
                    setSearchingPPOE(false);
                },500)
            }  
        }); 
    };

    const handleShowWifiInformation= ()=>{
        setShowWifiInfo(true);
        const objeto = {};
        objeto.IPCLIENTE = data.AddressIp;
        fetch('/api/ShowWifiInformation',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            console.log(result.message)
            if(result.message){
                Swal.fire({
                    title:result.message,
                    icon:'success',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                });
                setTimeout(()=>{
                    setShowWifiInfo(false);
                },500)
            }else{
                Swal.fire({
                    title:result.status,
                    icon:'error',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                })
                setTimeout(()=>{
                    setShowWifiInfo(false);
                },500)
            }  
        }); 
    };

    const handleShowWifiAssociate = ()=>{
        setShowWifiAssociate(true);
        const objeto = {};
        objeto.IPCLIENTE = data.AddressIp;
        fetch('/api/ShowWifiAssociate',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            console.log(result.message)
            if(result.message){
                Swal.fire({
                    title:result.message,
                    icon:'success',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                });
                setTimeout(()=>{
                    setShowWifiAssociate(false);
                },500)
            }else{
                Swal.fire({
                    title:result.status,
                    icon:'error',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                })
                setTimeout(()=>{
                    setShowWifiAssociate(false);
                },500)
            }  
        }); 
    };

    const handleShowOpticInformacion = ()=>{
        setSearchingOptic(true);
        const objeto = {};
        objeto.IPCLIENTE = data.AddressIp;
        fetch('/api/ShowOpticInformation',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                Swal.fire({
                    title:result.message,
                    icon:'success',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                });
                setTimeout(()=>{
                    setSearchingOptic(false);
                },500)
            }else{
                Swal.fire({
                    title:result.status,
                    icon:'error',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                })
                setTimeout(()=>{
                    setSearchingOptic(false);
                },500)
            } 
            
        }); 
    };

    const handleOnWifi = ()=>{
        setOnWifi(true);
        const objeto = {};
        objeto.IPCLIENTE = data.AddressIp;
        fetch('/api/HuaweiOnWifi',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                enqueueSnackbar(result.message, {variant:'success'});
                setTimeout(()=>{
                    setOnWifi(false);
                },500)
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
                setTimeout(()=>{
                    setOnWifi(false);
                },500)
            }            
        }); 
    };

    const handleOffWifi = ()=>{
        setOffWifi(true);
        const objeto = {};
        objeto.IPCLIENTE = data.AddressIp;
        fetch('/api/HuaweiOffWifi',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                enqueueSnackbar(result.message, {variant:'success'});
                setTimeout(()=>{
                    setOffWifi(false);
                },500)
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
                setTimeout(()=>{
                    setOffWifi(false);
                },500)
            }           
        }); 
    };

    const handleHiddenWifi = ()=>{
        setHiddenWifi(true);
        const objeto = {};
        objeto.IPCLIENTE = data.AddresIp;
        fetch('/api/HuaweiHiddenWifi',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                enqueueSnackbar(result.message, {variant:'success'});
                setTimeout(()=>{
                    setHiddenWifi(false);
                },500)
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
                setTimeout(()=>{
                    setHiddenWifi(false);
                },500)
            } 
        }); 
    };

    const handleNoHiddenWifi = ()=>{
        setNoHiddenWifi(true);
        const objeto = {};
        objeto.IPCLIENTE = data.AddresIp;
        fetch('/api/HuaweiNoHiddenWifi',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                enqueueSnackbar(result.message, {variant:'success'});
                setTimeout(()=>{
                    setNoHiddenWifi(false);
                },500)
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
                setTimeout(()=>{
                    setNoHiddenWifi(false);
                },500)
            } 
        }); 
    };

    const handleClickChangeName = ()=>{ 
        setNameChange(true);
        const objeto = {};
        objeto.IPCLIENTE = data.AddressIp;
        objeto.NAMEWIFI = getNameWifi;
        objeto.idCliente = dataCliente._id;
        objeto.idServicio = data._id;
        fetch('/api/HuaweiChangeNameWifi',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                enqueueSnackbar(result.message, {variant:'success'});
                setDatosD({...DatosD, NameWifi:getNameWifi});
                setTimeout(()=>{
                    setNameChange(false);
                },500)
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
                setTimeout(()=>{
                    setNameChange(false);
                },500)
            } 
        }); 
    };

    const handleNameWifi = ({target})=>{ setNameWifi(target.value) };

    const handleRebootOnt = ()=>{
        setRebootOnt(true);
        const objeto = {};
        objeto.IPCLIENTE = data.AddressIp;
        fetch('/api/HuaweiRebootOnt',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                enqueueSnackbar(result.message, {variant:'success'});
                setTimeout(()=>{
                    setRebootOnt(false);
                },500)
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
                setTimeout(()=>{
                    setRebootOnt(false);
                },500)
            } 
        });
    };


    return(
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
            <Dialog
                open={openPhoto}
                onClose={handleClosePhoto}
                fullWidth
                maxWidth={'sm'}
                style={{padding:0}}
            >
                <DialogTitle id="customized-dialog-title" onClose={handleClosePhoto}>
                    <Grid container justifyContent='center' spacing={1}>
                        <Grid item style={{display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center'}}>
                            <Chip color='secondary' label='FOTOS REFERENCIA' style={{fontWeight:'bolder'}}/>
                        </Grid>
                        <Grid item style={{display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center'}}>
                            <Tooltip title='ADD PHOTO' arrow placement='right'>
                                <span>
                                <IconButton size='medium' onClick={handleAddPhoto} >
                                    <AddCircleIcon color='primary'/>
                                </IconButton>
                                </span>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent style={{margin:0, padding:5, overflowX:'hidden'}}>
                    <Divider />
                    <Paper variant="outlined" square style={{padding:10, width:'100%'}} >
                    <Grid container justifyContent='center' spacing={2}>                   
                    {
                        getArrPhotos.map((infoPhoto, index)=> 
                            <Grid item key={`tiptraphoto_${index}`}>
                                <UploadElementYouNET
                                    classes={classes}
                                    handleUpdatePhoto={handleUpdatePhoto}
                                    info={infoPhoto}
                                    handleDeletePhoto={handleDeletePhoto}
                                    idForMikrotik={data.idForMikrotik}
                                    idServicio={data._id}
                                    idCliente={dataCliente._id}
                                    getArrPhotos={getArrPhotos}
                                />
                            </Grid>
                        )
                    }
                    </Grid>
                     </Paper>
                    
                </DialogContent>
            </Dialog> 
            <ModalAntd title="CONFIGURACIONES WIFI" visible={openConfWifi} onCancel={handleCloseConfWifi} okButtonProps={{disabled:true, type:'ghost'}}>
                <Paper variant="outlined" square style={{padding:10, width:'100%'}} >
                    <Grid container justifyContent='space-between' spacing={2}> 
                        <Grid item xs={12}>
                            <Grid container justifyContent='space-around' spacing={1}>                   
                                <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                    <TooltipAntd title="ON WIFI" color='purple' placement='right'>
                                        <Popconfirm
                                            title="DESEA ENCENDER LA RED WIFI?"
                                            onConfirm={handleOnWifi}
                                            okText="SI"
                                            cancelText="NO"
                                        >
                                            <ButtonAntd shape='circle' type="primary" icon={isOnWifi ? <LoadingOutlinedIcon /> : <PoweroffOutlinedIcon />} size='large' />
                                        </Popconfirm>
                                    </TooltipAntd>
                                </Grid>
                                <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                    <TooltipAntd title="OFF WIFI" color='purple' placement='left'>
                                        <Popconfirm
                                            title="DESEA APAGAR LA RED WIFI?"
                                            onConfirm={handleOffWifi}
                                            okText="SI"
                                            cancelText="NO"
                                        >
                                            <ButtonAntd shape='circle' type="danger" icon={isOffWifi ? <LoadingOutlinedIcon /> : <PoweroffOutlinedIcon />} size='large' />
                                        </Popconfirm>
                                    </TooltipAntd>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container justifyContent='space-around' spacing={1}>                   
                                <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                    <TooltipAntd title="VISIBLE WIFI" color='purple' placement='right'>
                                        <Popconfirm
                                            title="DESEA PONER VISIBLE LA RED WIFI?"
                                            onConfirm={handleNoHiddenWifi}
                                            okText="SI"
                                            cancelText="NO"
                                        >
                                            <ButtonAntd shape='circle' type="primary" icon={isNoHiddenWifi ? <LoadingOutlinedIcon /> : <EyeOutlinedIcon />} size='large'/>
                                        </Popconfirm>
                                    </TooltipAntd>
                                </Grid>
                                <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                    <TooltipAntd title="OCULTAR WIFI" color='purple' placement='left' >
                                        <Popconfirm
                                            title="DESEA OCULTAR LA RED WIFI?"
                                            onConfirm={handleHiddenWifi}
                                            okText="SI"
                                            cancelText="NO"
                                        >
                                            <ButtonAntd shape='circle' type="ghost" icon={isHiddenWifi ? <LoadingOutlinedIcon /> : <EyeInvisibleOutlinedIcon />} size='large' />
                                        </Popconfirm>
                                    </TooltipAntd>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container justifyContent='space-around' spacing={1}>                   
                                <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}} xs={12}>
                                    <TextField 
                                        id='nameWifiHuawei'
                                        fullWidth
                                        label='NOMBRE WIFI'
                                        value={getNameWifi || ''}
                                        onChange={handleNameWifi}
                                        variant='outlined'
                                        size='large'
                                        margin='dense'
                                    />
                                </Grid>
                                <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}} xs={8}>
                                        <Popconfirm
                                            title="DESEA CAMBIAR EL NOMBRE DE LA RED WIFI?"
                                            onConfirm={handleClickChangeName}
                                            okText="SI"
                                            cancelText="NO"
                                        >
                                            <ButtonAntd type="primary"  size='large' icon={isChangeName ? <LoadingOutlinedIcon/> :<SyncOutlinedIcon/>} >
                                                CAMBIAR NOMBRE
                                            </ButtonAntd>
                                        </Popconfirm>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
            </ModalAntd> 
            
            <Paper elevation={3} style={{padding:5}} key={`servicio${index}`}>
                <Grid container  spacing={1} >
                    <Grid item xs={12} style={{display:'flex', flexDirection:'row', justifyContent:'center'}}>
                        <Grid container spacing={2} justifyContent='center'>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center', height:42, alignText:'center',}}>
                                {
                                    data.Status === 'Activo' ?
                                        <TooltipAntd title="SERVICIO ACTIVO" color='green'>
                                            <CheckCircleIcon style={{color:'green', marginTop:15}} fontSize='large'/>
                                        </TooltipAntd>
                                        :
                                        <TooltipAntd title="SERVICIO SUSPENDIDO" color='red'>
                                            <BlockIcon style={{color:'red', marginTop:15}} fontSize='large'/>
                                        </TooltipAntd>
                                }                                       
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="STATUS ONT" color='purple'>
                                    <ButtonAntd type="primary" icon={isSearchingOnu ? <LoadingOutlinedIcon /> : <ApiOutlinedIcon />} size='large' onClick={handleSearchOnu}/>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="STATUS PPOE" color='purple'>
                                    <ButtonAntd type="primary" icon={isSearchingPPOE ? <LoadingOutlinedIcon/> : <SecurityScanOutlinedIcon />} size='large' onClick={handleSearchPPOE}/>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="ESTADO OPTICO" color='purple'>
                                    <ButtonAntd style={{background:'OliveDrab'}} type="primary" icon={getSearchingOptic ? <LoadingOutlinedIcon /> : <ClusterOutlinedIcon />} size='large' onClick={handleShowOpticInformacion}/>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="WIFI DETALLES" color='purple'>
                                    <ButtonAntd style={{background:'teal'}} type="primary" icon={getShowWifiInfo ? <LoadingOutlinedIcon /> : <WifiOutlinedIcon />} size='large' onClick={handleShowWifiInformation}/>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="DISP. CONECTADOS AL WIFI" color='purple'>
                                    <ButtonAntd style={{background:'green'}} type="primary" icon={getShowWifiAssociate ? <LoadingOutlinedIcon /> : <TeamOutlinedIcon />} size='large' onClick={handleShowWifiAssociate}/>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="CONF. WIFI" color='purple'>
                                    <ButtonAntd style={{background:'MediumSlateBlue'}} type="primary" icon={<SettingOutlinedIcon />} size='large' onClick={handleOpenConfWifi}/>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="REINICIAR ONT" color='purple' placement='right'>
                                    <Popconfirm
                                        title="DESEA REINICIAR LA ONT?"
                                        onConfirm={handleRebootOnt}
                                        okText="SI"
                                        cancelText="NO"
                                    >
                                        <ButtonAntd shape='circle' type="primary" icon={isRebootOnt ? <LoadingOutlinedIcon /> : <PoweroffOutlinedIcon />} size='large' />
                                    </Popconfirm>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="CREAR PDF" color='purple'>
                                    <ButtonAntd type="danger" icon={<FilePdfOutlinedIcon />} size='large' onClick={handleCreatePdf}/>
                                </TooltipAntd>
                            </Grid>
                            <Grid item >
                                {
                                    data.TipoServicio === 'Fibra Optica' ? 
                                    <Fragment>
                                        {isReadyPdf && <PdfInstalacionFibra data={data} handleClickPdf={handleClickPdf} dataCliente={dataCliente}/>}
                                    </Fragment> : 
                                    <Fragment>
                                        {isReadyPdf && <PdfInstalacionRadio data={data} handleClickPdf={handleClickPdf} dataCliente={dataCliente}/>}
                                    </Fragment>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs ={12} style={{height:300}}>
                        < div
                            ref={ mapDiv }
                            style={{width:'100%', height:'100%'}}
                        />
                    </Grid>
                    <Grid item md={6} xs={12} >
                        <TextField 
                            id='idForMikrotik'
                            fullWidth
                            label='idMikrotik'
                            value={data.idForMikrotik || ''}
                            variant='outlined'
                            size='small'
                            margin='dense'
                            InputProps={{ 
                                startAdornment: <WhatshotIcon/>, 
                                endAdornment:
                                <IconButton size='small' onClick={copyToClipBoardUser} color='primary'>
                                    <ContentCopyIcon/>
                                </IconButton>
                            }} 
                        />
                    </Grid>
                    <Grid item md={6} xs={12} >
                        <TextField 
                            id='Plan' 
                            fullWidth
                            label='Plan'
                            value={data.Plan || ''}   
                            variant='outlined'
                            size='small'
                            margin='dense'
                        />
                    </Grid>
                    <Grid item xs={12} >
                        <TextField 
                            id='Direccion'
                            fullWidth
                            label='Direccion'
                            value={data.Direccion || ''}
                            InputProps={{ startAdornment: <PlaceIcon/>  }}
                            variant='outlined'
                            multiline
                            rows={2}
                        />
                    </Grid>    
                    <Grid item xs={12} >
                        <TextField 
                            id='Referencia'
                            fullWidth
                            label='Referencia'
                            value={DatosD.Referencia || ''}
                            variant='outlined'
                            multiline
                            InputProps={{
                                startAdornment: <PlaceIcon/>,
                                endAdornment: 
                                <IconButton aria-label="search" onClick={handleOpenPhoto} size='medium'>
                                    <PhotoIcon color='primary' />
                                </IconButton>
                            }}
                        />
                    </Grid>   
                    <Grid item md={6} xs={12} >
                        <TextField 
                            id='Coordenadas'
                            fullWidth
                            label='Coordenadas'
                            value={DatosD.Coordenadas || ''}
                            variant='outlined'
                            InputProps={{
                                endAdornment: 
                                <IconButton aria-label="search" onClick={handleCoordenadas} size='medium'>
                                    <GpsFixedIcon color='primary' />
                                </IconButton>
                            }}
     
                        />
                    </Grid>
                    <Grid item md={6} xs={12} >
                        <TextField 
                            id='Subnet' 
                            fullWidth
                            label='Subnet'
                            value={data.Red || ''}   
                            variant='outlined'

                            
                        />
                    </Grid>
                    <Grid item md={6} xs={12} >
                        <TextField 
                            id='AddressIp' 
                            fullWidth
                            label='AddressIp'
                            value={data.AddressIp || ''}   
                            variant='outlined'
                            size='small'
                            margin='dense'
                        />
                    </Grid>  
                    <Grid item md={6} xs={12} >
                        <TextField 
                            id='ONU' 
                            fullWidth
                            label='ONU'
                            value={data.Onu || ''}   
                            variant='outlined'
                            size='small'
                            margin='dense'
                        />
                    </Grid>
                    <Grid item md={6} xs={12} >
                        <TextField 
                            id='MacOnu' 
                            fullWidth
                            label='MacOnu'
                            value={data.MacOnu || ''}   
                            variant='outlined'
                            size='small'
                            margin='dense'
                        />
                    </Grid>
                    <Grid item md={6} xs={12} >
                        <TextField 
                            id='SN' 
                            fullWidth
                            label='SN'
                            value={data.SN || ''}   
                            variant='outlined'
                            size='small'
                            margin='dense'
                        />
                    </Grid>
                    <Grid item md={6} xs={12} >
                        <TextField 
                            id='UserPPOE'
                            fullWidth
                            label='UserPPOE'
                            value={data.UserPPOE || ''}
                            InputProps={{
                                startAdornment:<DnsIcon/>,
                                endAdornment:
                                <IconButton size='small' onClick={copyToClipBoardUserP} color='primary'>
                                    <ContentCopyIcon/>
                                </IconButton>
                            }}
                            variant='outlined'
                            size='small'
                            margin='dense'
                        />
                    </Grid>
                    <Grid item md={6} xs={12}  >
                        <TextField 
                            id='PassPPOE'
                            fullWidth
                            label='PassPPOE'
                            value={data.PassPPOE || ''}
                            InputProps={{
                                startAdornment:<DnsIcon/>,
                                endAdornment:
                                <IconButton size='small' onClick={copyToClipBoardPass} color='primary'>
                                    <ContentCopyIcon/>
                                </IconButton>
                            }}
                            
                            variant='outlined'
                            size='small'
                            margin='dense'
                        />
                    </Grid>
                    {/* {
                        isOnuBridge &&
                        <Fragment>
                            <Grid item md={6} xs={12} >
                                <TextField 
                                    id='Router' 
                                    fullWidth
                                    label='Router'
                                    value={data.Router || ''}   
                                    variant='outlined'
                                    size='small'
                                    margin='dense'
                                />
                            </Grid>
                            <Grid item md={6} xs={12} >
                                <TextField 
                                    id='MacRouter' 
                                    fullWidth
                                    label='MacRouter'
                                    value={data.MacRouter || ''}   
                                    variant='outlined'
                                    size='small'
                                    margin='dense'
                                />
                            </Grid>                    
                        </Fragment>
                    }      */}
                    <Grid item md={6} xs={12} >
                        <TextField 
                            id='UserMk'
                            fullWidth
                            label='UserLogin'
                            value={data.UserMk || ''}
                            variant='outlined'
                            size='small'
                            margin='dense'
                        />
                    </Grid>
                    <Grid item md={6} xs={12} >
                        <TextField 
                            id='PassMk'
                            fullWidth
                            label='PassLogin'
                            value={data.PassMk || ''}
                            variant='outlined'
                            margin='dense'
                            size='small'
                        />
                    </Grid>            
                    <Grid item md={6} xs={12} >
                        <TextField 
                            id='ValorInstalacion'
                            fullWidth
                            label='ValorInstalacion'
                            value={data.ValorInstalacion}
                            InputProps={{
                                startAdornment:<MonetizationOnIcon/>
                            }}
                            variant='outlined'
                            size='small'
                            margin='dense'
                            type='Number'
                        />    
                    </Grid>
                    <Grid item md={6} xs={12} > 
                        <TextField 
                            id='Instalacion'
                            fullWidth
                            label='Instalacion'
                            value={data.Instalacion || ''}
                            InputProps={{
                                startAdornment:<DnsIcon/>
                            }}
                            variant='outlined'
                            size='small'
                            margin='dense'
                            type='date'
                        />                     
                    </Grid>
                    <Grid item md={6} xs={12} > 
                        <TextField 
                            id='HoraInstalacion'
                            fullWidth
                            label='HoraInstalacion'
                            value={data.HoraInstalacion || ''}
                            InputProps={{
                                startAdornment:<DnsIcon/>
                            }}
                            
                            variant='outlined'
                            size='small'
                            margin='dense'
                            type='time'
                        />                     
                    </Grid>
                    <Grid item md={6} xs={12} >
                        <TextField 
                            id='NameWifi'
                            fullWidth
                            label='NameWifi'
                            value={data.NameWifi || ''}
                            
                            variant='outlined'
                            size='small'
                            margin='dense'
                        />
                    </Grid>
                    <Grid item md={6} xs={12} >
                        <TextField 
                            id='PassWifi'
                            fullWidth
                            label='PassWifi'
                            value={data.PassWifi || ''}
                            
                            variant='outlined'
                            size='small'
                            margin='dense'
                        />
                    </Grid>
                    <Grid item md={6} xs={12} >
                        <TextField 
                            id='Comentario'
                            fullWidth
                            label='Comentario'
                            value={data.Comentario || ''}
                            
                            variant='outlined'
                            size='small'
                            margin='dense'
                        />
                    </Grid>
                </Grid>
            </Paper>
        </Grid>
    )
});

const ElementServiciosRadio = memo((props)=>{
    const { 
        classes, data, index, 
        zonaSelected, 
        dataCliente, 
        getArrAp,
    } = props;
    const [ DatosD, setDatosD] = useState({
        Instalacion:'',
        AddressIp:'',
        Plan:'',
        ValorInstalacion:'',
        idForMikrotik:'',
        ZonaService:zonaSelected.Zona,
        TipoPagoBoolean:true,
        CorteAutomatico:true,
        StatusIns:false,
        Coordenadas:'',
        Router:'',
        MacRouter:'',
        Modelo:'',
        MacModelo:'',
        Red:'',
        Mascara:'',
        Status:'',
        UserMk:'admin',
        PassMk:'Apolo$$2019',
        IVA:false,
        DiaNotificacion:1,
        DiasCorte:4,
    });
    const [ isReadyPdf, setReadyPdf ] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [ openPhoto, setOpenPhoto ] = useState(false);
    const [ getArrPhotos, setArrPhotos ] = useState([]);
    const [ isDstPort, setDstPort ] = useState(false);
    const [ informacionAPCPE, setInformacionAPCPE ] = useState([]);
    const [ continuoInformacionCPE, setContinuoInformacionCPE ] = useState(false);
    const [ isInfoCharging, setInfoCharging ] = useState(false);
    const [ isInfoCharging2, setInfoCharging2 ] = useState(false);
    const [ openDialogInformacionCPE, setOpenDialogInformacionCPE ] = useState(false);
    const [ isReadyCPE, setReadyCPE ] = useState(false);
    const [ getOpenStatusCPE, setOpenStatusCPE ] = useState(false);
    const [ getInfoCPE, setInfoCPE ] = useState({});
    const [ isReadyInterfaces, setReadyInterfaces ] = useState(false);
    const [ getOpenInterfaces, setOpenInterfaces ] = useState(false);
    const [ getInterfaces, setInterfaces ] = useState({});
    const [ isInterfacesCharging, setInterfacesCharging]  = useState(false);
    const [ isRebootCPE, setRebootCPE ] = useState(false);
    const [ getOpenComandos, setOpenComandos ] = useState(false);
    const [ isRemovingArp, setRemovingArp ] = useState(false);
    const [ getPassCPE, setPassCPE ] = useState(false);
    const [ getInfoWlan, setInfoWlan ] = useState(false);
    const mapDiv = useRef();
    const mapa = useRef();

    useEffect(()=>{
        setDatosD(data); 
        setArrPhotos(data.FotosReferencia ? data.FotosReferencia.length > 0 ? data.FotosReferencia : [] : []) 
        var map = new mapboxgl.Map({
            container: mapDiv.current,
            style: 'mapbox://styles/mapbox/satellite-v9',
            center: [ 
                data.Coordenadas === '' ? '-79.93395424851998' : 
                data.Coordenadas === undefined ? '-79.93395424851998' : data.Coordenadas.split(',')[1], 
                data.Coordenadas === '' ? '-2.201567808901885' : 
                data.Coordenadas === undefined ? '-2.201567808901885' : data.Coordenadas.split(',')[0] ] ,
            zoom: 16.80
        });

        const marker = new mapboxgl.Marker();
            marker.id = data._id;
            marker
                .setLngLat(
                    [ 
                        data.Coordenadas === '' ? '-79.93395424851998' : 
                        data.Coordenadas === undefined ? '-79.93395424851998' : data.Coordenadas.split(',')[1], 
                        data.Coordenadas === '' ? '-2.201567808901885' : 
                        data.Coordenadas === undefined ? '-2.201567808901885' : data.Coordenadas.split(',')[0] ]
                )
                .addTo( map )
                .setDraggable(true)

            marker.on('dragend', ({target})=>{
                handleUpdateCoor(target._lngLat);
            })

        mapa.current = map;
    },[]);// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(()=>{
        if(continuoInformacionCPE){
            setContinuoInformacionCPE(false);
            setOpenDialogInformacionCPE(true);
        }
    },[continuoInformacionCPE]);

    useEffect(()=>{
        if(isReadyCPE){
            setReadyCPE(false);
            setOpenStatusCPE(true);
        }
    },[isReadyCPE]);

    useEffect(()=>{
        if(isReadyInterfaces){
            setReadyInterfaces(false);
            setOpenInterfaces(true);
        }
    },[isReadyInterfaces]); 

    const handleCreatePdf = ()=>{ setReadyPdf(true); };

    const handleClickPdf = useCallback(()=>{
        setTimeout(()=>{
            setReadyPdf(false);
        },[2000]);
    },[]);

    const handleOpenPhoto = ()=>{ setOpenPhoto(true) };

    const handleClosePhoto = ()=>{ setOpenPhoto(false) };

    const handleUpdatePhoto = useCallback((info)=>{
        setArrPhotos(info);
    },[]);

    const handleDeletePhoto = useCallback((info)=>{
        const arr = [...getArrPhotos];
        const arrNew = arr.filter(el=>el.id !== info.id);
        setArrPhotos(arrNew);
    },[getArrPhotos]);

    const handleAddPhoto = ()=>{
        if(data.idForMikrotik === ''){
            Swal.fire({
                title:'ERROR',
                icon:'error',
                text:'Primero debe asignar un idForMikrotik',
                width:600,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonColor:'#005596',
                confirmButtonText:'OK',
                toast:true
            })
        }else{ 
            const arr = [...getArrPhotos];
            const objeto = {};
            objeto.src = '';
            objeto.id = `photo_${uuidv4()}`;
            objeto.idForMikrotik = data.idForMikrotik;
            arr.push(objeto);
            setArrPhotos(arr);
        }
    };

    const handleCoordenadas = ()=>{
        var options = {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
        };

        function success(pos) {
            var crd = pos.coords;    
            //setCoordenadas({Latitud:crd.latitude, Longitud:crd.longitude});  
            setDatosD({...DatosD, Coordenadas:`${crd.latitude}, ${crd.longitude}`});  
            const objeto = {idCliente:dataCliente._id, idServicio:data._id, Coordenadas:`${crd.latitude}, ${crd.longitude}`}
            fetch('/api/clientes/serviciosCoordenadas',{
                method:'PUT',
                body: JSON.stringify(objeto),
                headers:{
                    'Content-Type': 'application/json'
                }
            }) 
            .then(response=> response.json())
            .then(result =>{
                if(result.message){
                    enqueueSnackbar(result.message, {variant:'success'});
                    var map = new mapboxgl.Map({
                        container: mapDiv.current,
                        style: 'mapbox://styles/mapbox/satellite-v9',
                        center: [ crd.longitude, crd.latitude ] ,
                        zoom: 16.80
                    });
            
                    const marker = new mapboxgl.Marker();
                        marker.id = data._id;
                        marker
                            .setLngLat(
                                [ crd.longitude, crd.latitude ]
                            )
                            .addTo( map )
                            .setDraggable(true)

                        marker.on('dragend', ({target})=>{
                            handleUpdateCoor(target._lngLat);
                        })
                    mapa.current = map;
                }else{
                    enqueueSnackbar(result.status, {variant:'error'});
                }
            })
        };
          
        function error(err) {
            console.warn('ERROR(' + err.code + '): ' + err.message);
        };

        navigator.geolocation.getCurrentPosition(success, error, options);
    };

    const handleUpdateCoor = (dataMarked)=>{
        setDatosD({...DatosD, Coordenadas:`${dataMarked.lat.toString()}, ${dataMarked.lng.toString()}`});  
        const objeto = {idCliente:dataCliente._id, idServicio:data._id, Coordenadas:`${dataMarked.lat.toString()}, ${dataMarked.lng.toString()}`}
        fetch('/api/clientes/serviciosCoordenadas',{
            method:'PUT',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){             
                enqueueSnackbar(result.message, {variant:'success'});
            }else{         
                enqueueSnackbar(result.status, {variant:'error'});
            }
        })
    };

    const copyToClipBoardUser = ()=>{  
        copy(data.idForMikrotik) 
        enqueueSnackbar('Copiado', {variant:'success'});
    };


    const handleDstPort8880 =()=>{
        setDstPort(true);
        const objeto = {};
        objeto.IPUSUARIO = data.AddressIp;
        objeto.USERMK = data.UserMk;
        objeto.PASSMK = data.PassMk;
        fetch('/api/MikrotikDstNatPort8880',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            console.log(result);
            if(result.message){
                enqueueSnackbar(result.message, {variant:'success'});
                setTimeout(()=>{
                    setDstPort(false);
                },500)
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
                setTimeout(()=>{
                    setDstPort(false);
                },500)
            } 
        });
    };

    const handleInformacionCPE = ()=>{
        const filterAp = getArrAp.filter(el=> el.SSID === data.AP);
        console.log(filterAp)
        if(filterAp.length > 0 ){
            const rowInfo = filterAp[0];
            if(rowInfo.isLocal){ 
                setInfoCharging(true);
                fetch('api/mikrotik/ap/cpe',{
                    method:'POST',
                    body: JSON.stringify(rowInfo),
                    headers:{
                        'Content-Type': 'application/json'
                    }
                }) 
                .then(response=> response.json())
                .then(result =>{
                    console.log(result)
                    if(result.status){
                        Swal.fire({
                            title:result.status,
                            icon:'error',
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonColor:'#005596',
                            toast:true,
                        })
                        setInfoCharging(false);
                    }else{
                        const arr = []
                        result.forEach(value2=>{
                            const objeto = {};
                            //console.log(value2)
                            for(const x of value2){
                                const splitKey = x.field.split('-');
                                switch(splitKey.length){
                                    case 1: 
                                        objeto[x.field] = x.value; 
                                        break;
                                    case 2: 
                                        let x2 = `${splitKey[0].toString()}${capitalize(splitKey[1])}`
                                        objeto[x2] = x.value; 
                                        break;
                                    case 3: 
                                        let x3 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}`
                                        objeto[x3] = x.value; 
                                        break;
                                    case 4: 
                                        let x4 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}${capitalize(splitKey[3])}`
                                        objeto[x4] = x.value; 
                                        break;
                                    default:
                                        objeto[x.field] = x.value; 
                                        break;
                                }
                            };
                            arr.push(objeto);
                        });
                        console.log(arr);
                        setInformacionAPCPE(arr);
                        setContinuoInformacionCPE(true);
                        setInfoCharging(false);
                    }
                }); 
            }else{
                Swal.fire({
                    title:'Informacion No Disponible',
                    icon:'info',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                });
            }
        }else{
            enqueueSnackbar('NO EXISTE ESTE AP', {variant:'error'})
        }  
    };

    const handleVerificarCPE = ()=>{
        const filterAp = getArrAp.filter(el=> el.SSID === data.AP);
        if(filterAp.length > 0 ){
            const rowInfo = filterAp[0];
            if(rowInfo.isLocal){ 
                setInfoCharging(true);
                fetch('api/mikrotik/ap/cpe',{
                    method:'POST',
                    body: JSON.stringify(rowInfo),
                    headers:{
                        'Content-Type': 'application/json'
                    }
                }) 
                .then(response=> response.json())
                .then(result =>{
                    setInfoCharging(false);
                    console.error(result)
                    if(result.status){
                        Swal.fire({
                            title:result.status,
                            icon:'error',
                            showDenyButton: false,
                            showCancelButton: false,
                            confirmButtonColor:'#005596',
                            toast:true,
                        })

                    }else{
                        const arr = [];
                        for(const u in result){
                            const objeto = {};
                            for(const x of result[u]){
                                const splitKey = x.field.split('-');
                                switch(splitKey.length){
                                    case 1: 
                                        objeto[x.field] = x.value; 
                                        break;
                                    case 2: 
                                        let x2 = `${splitKey[0].toString()}${capitalize(splitKey[1])}`
                                        objeto[x2] = x.value; 
                                        break;
                                    case 3: 
                                        let x3 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}`
                                        objeto[x3] = x.value; 
                                        break;
                                    case 4: 
                                        let x4 = `${splitKey[0].toString()}${capitalize(splitKey[1])}${capitalize(splitKey[2])}${capitalize(splitKey[3])}`
                                        objeto[x4] = x.value; 
                                        break;
                                    default:
                                        objeto[x.field] = x.value; 
                                        break;
                                }
                            };
                            arr.push(objeto);
                        }
                        const arrMap = arr.map(el=> el.lastIp);
                        if(arrMap.length > 0){
                            const arrFilterCpe = arrMap.filter(el=> el === data.AddressIp);
                            if(arrFilterCpe.length > 0){
                                Swal.fire({
                                    title:'SI EXISTE CONEXION ENTRE AP Y CPE',
                                    icon:'success',
                                    showDenyButton: false,
                                    showCancelButton: false,
                                    confirmButtonColor:'#005596',
                                    toast:true,
                                });
                            }else{
                                Swal.fire({
                                    title:'NO EXISTE CONEXION ENTRE AP Y CPE',
                                    icon:'error',
                                    showDenyButton: false,
                                    showCancelButton: false,
                                    confirmButtonColor:'#005596',
                                    toast:true,
                                });
                            }
                        }else{
                            Swal.fire({
                                title:'NO EXISTE CONEXION ENTRE AP Y CPE',
                                icon:'error',
                                showDenyButton: false,
                                showCancelButton: false,
                                confirmButtonColor:'#005596',
                                toast:true,
                            });
                        }
                    }
                }); 
            }else{
                Swal.fire({
                    title:'Informacion No Disponible',
                    icon:'info',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    toast:true,
                });
            }
        }else{
            enqueueSnackbar('NO EXISTE ESTE AP', {variant:'error'})
        } 
    };

    const handleStatusCPE = ()=>{
        setInfoCharging2(true);
        const objeto = {};
        objeto.IPUSUARIO = data.AddressIp;
        objeto.USERMK = data.UserMk;
        objeto.PASSMK = data.PassMk;
        fetch('api/mikrotik/StatusCPE',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            setInfoCharging2(false);
            //console.log(result);
            if(result.status){
                enqueueSnackbar(result.status,{variant:'error'});               
            }else{
                setInfoCPE(result[0]);
                setReadyCPE(true);
            }
        });   
    };

    const handleInterfaces = ()=>{
        setInterfacesCharging(true);
        const objeto = {};
        objeto.IPUSUARIO = data.AddressIp;
        objeto.USERMK = data.UserMk;
        objeto.PASSMK = data.PassMk;
        fetch('api/mikrotik/InterfacesCPE',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            console.log(result)
            setInterfacesCharging(false);
            if(result.status){
                enqueueSnackbar(result.status, {variant:'error'});
            }else{
                const objeto = {};
                    objeto.Status = result[0].running === 'true' ? 'online' : 'offline';
                    objeto.UltimaDesconexion = result[0]['last-link-up-time'];
                    objeto.MacWlan = result[1]['mac-address'];
                    objeto.MacLan = result[0]['mac-address'];
                    objeto.MacRouter = result.length === 3 ? 'offline' : result[2]['mac-address'] ? result[2]['mac-address'] : 'offline';
                    objeto.isStatic = result.length === 3 ? 'offline' : result[2].dynamic === "true" ? 'NO' : 'SI';
                setInterfaces(objeto);
                setReadyInterfaces(true);
            }
            
            
            
        });   
    };

    const handleRebootCPE = ()=>{
        setRebootCPE(true);
        const objeto = {};
        objeto.IPUSUARIO = data.AddressIp;
        objeto.USERMK = data.UserMk;
        objeto.PASSMK = data.PassMk;
        fetch('api/mikrotik/RebootCPE',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                enqueueSnackbar(result.message, {variant:'success'});
                setTimeout(()=>{
                    setRebootCPE(false);
                },500)
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
                setTimeout(()=>{
                    setRebootCPE(false);
                },500)
            } 
        });   
    };

    const handleAlertCloseCPE = ()=>{ setOpenDialogInformacionCPE(false); };

    const handleCloseInfoCPE = ()=>{ setOpenStatusCPE(false); };

    const handleCloseInterfaces = ()=>{ setOpenInterfaces(false); };

    const handleSyncMikrotikNew = ()=>{
        const filterAp = getArrAp.filter(el=> el.SSID === data.AP);
        if(filterAp.length > 0 ){
            const objeto = {};
                objeto.INFOAP = filterAp[0];
                objeto.NOMBRES = `${dataCliente.Nombres} || ${data.idForMikrotik}`;
                objeto.IPUSUARIO = data.AddressIp;
                objeto.USERMK = data.UserMk;
                objeto.PASSMK = data.PassMk;
                objeto.ISNEW = true;
            fetch('/api/Mikrotik/syncMikrotikNew',{
                method:'POST',
                body: JSON.stringify(objeto),
                headers:{
                    'Content-Type': 'application/json'
                }
            }) 
            .then(response=> response.json())
            .then(resultSync =>{
                console.error(resultSync)
                if(resultSync.message){
                    enqueueSnackbar(resultSync.message, {variant:'success'});
                }else{
                    enqueueSnackbar(resultSync.status, {variant:'error'});
                }     
            })

        }else{
            enqueueSnackbar('NO EXISTE ESTE AP', {variant:'error'});
        }
        
    };

    const handleSyncMikrotik = ()=>{
        const filterAp = getArrAp.filter(el=> el.SSID === data.AP);
        if(filterAp.length > 0 ){
            const objeto = {};
                objeto.INFOAP = filterAp[0];
                objeto.NOMBRES = `${dataCliente.Nombres} || ${data.idForMikrotik}`;
                objeto.IPUSUARIO = data.AddressIp;
                objeto.USERMK = data.UserMk;
                objeto.PASSMK = data.PassMk;
                objeto.ISNEW = false;
            fetch('/api/Mikrotik/syncMikrotikNew',{
                method:'POST',
                body: JSON.stringify(objeto),
                headers:{
                    'Content-Type': 'application/json'
                }
            }) 
            .then(response=> response.json())
            .then(resultSync =>{
                console.error(resultSync);
                if(resultSync.message){
                    enqueueSnackbar(resultSync.message, {variant:'success'});
                }else{
                    enqueueSnackbar(resultSync.status, {variant:'error'});
                }
            });
        }else{
            enqueueSnackbar('NO EXISTE ESTE AP', {variant:'error'});         
        }     
    };

    const copyMacRouter = ()=>{
        copy(getInterfaces.MacRouter) 
        enqueueSnackbar('Copiado', {variant:'success'});
    };

    const copyMacWlan = ()=>{
        copy(getInterfaces.MacWlan) 
        enqueueSnackbar('Copiado', {variant:'success'});
    };

    const copyMacLan = ()=>{
        copy(getInterfaces.MacLan) 
        enqueueSnackbar('Copiado', {variant:'success'});
    };

    const handleCloseComandos = ()=> { setOpenComandos(false); }

    const handleOpenComandos = ()=> { setOpenComandos(true); }

    const handleRemoveArp = ()=>{
        setRemovingArp(true);
        const objeto = {};
        objeto.IPUSUARIO = data.AddressIp;
        objeto.USERMK = data.UserMk;
        objeto.PASSMK = data.PassMk;
        fetch('api/mikrotik/RemoveArp',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                enqueueSnackbar(result.message, {variant:'success'});
                setTimeout(()=>{
                    setRemovingArp(false);
                },500)
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
                setTimeout(()=>{
                    setRemovingArp(false);
                },500)
            } 
        });
    };

    const handlePassCPE = ()=>{
        setPassCPE(true);
        const objeto = {};
        objeto.IPUSUARIO = data.AddressIp;
        objeto.USERMK = data.UserMk;
        objeto.PASSMK = data.PassMk;
        objeto.ISNEW = true;
        fetch('api/mikrotik/SetPassCPE',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                enqueueSnackbar(result.message, {variant:'success'});
                setTimeout(()=>{
                    setPassCPE(false);
                },500)
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
                setTimeout(()=>{
                    setPassCPE(false);
                },500)
            } 
        });
    };

    const handleInfoWlan = ()=>{
        setInfoWlan(true);
        const objeto = {};
        objeto.IPUSUARIO = data.AddressIp;
        objeto.USERMK = data.UserMk;
        objeto.PASSMK = data.PassMk;
        objeto.ISNEW = true;
        fetch('api/mikrotik/SetInfoWlan',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.message){
                enqueueSnackbar(result.message, {variant:'success'});
                setTimeout(()=>{
                    setInfoWlan(false);
                },500)
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
                setTimeout(()=>{
                    setInfoWlan(false);
                },500)
            } 
        });
    };

    return(
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
            <Dialog
                open={openPhoto}
                onClose={handleClosePhoto}
                fullWidth
                maxWidth={'sm'}
                style={{padding:0}}
            >
                <DialogTitle id="customized-dialog-title" onClose={handleClosePhoto}>
                    <Grid container justifyContent='center' spacing={1}>
                        <Grid item style={{display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center'}}>
                            <Chip color='secondary' label='FOTOS REFERENCIA' style={{fontWeight:'bolder'}}/>
                        </Grid>
                        <Grid item style={{display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center'}}>
                            <Tooltip title='ADD PHOTO' arrow placement='right'>
                                <span>
                                <IconButton size='medium' onClick={handleAddPhoto} >
                                    <AddCircleIcon color='primary'/>
                                </IconButton>
                                </span>
                            </Tooltip>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent style={{margin:0, padding:5, overflowX:'hidden'}}>
                    <Divider />
                    <Paper variant="outlined" square style={{padding:10, width:'100%'}} >
                    <Grid container justifyContent='center' spacing={2}>                   
                    {
                        getArrPhotos.map((infoPhoto, index)=> 
                            <Grid item key={`tiptraphoto_${index}`}>
                                <UploadElementYouNET
                                    classes={classes}
                                    handleUpdatePhoto={handleUpdatePhoto}
                                    info={infoPhoto}
                                    handleDeletePhoto={handleDeletePhoto}
                                    idForMikrotik={data.idForMikrotik}
                                    idServicio={data._id}
                                    idCliente={dataCliente._id}
                                    getArrPhotos={getArrPhotos}
                                />
                            </Grid>
                        )
                    }
                    </Grid>
                     </Paper>
                    
                </DialogContent>
            </Dialog> 
            <Dialog
                open={openDialogInformacionCPE}
                onClose={handleAlertCloseCPE}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth
                maxWidth='md'
            >
                <DialogTitle id="customized-dialog-title" onClose={handleAlertCloseCPE}>
                    Informacion C.P.E.
                </DialogTitle>
                <DialogContent>
                    <Paper stye={{width:'100%'}}>
                        <TableContainer style={{maxHeight: 440}}>
                            <Table stickyHeader aria-label="simple table" >
                                <TableHead>
                                <TableRow>
                                    <TableCell>CLIENTE</TableCell>
                                    <TableCell>MAC</TableCell>
                                    <TableCell>ULTIMA ACTIVIDAD</TableCell>
                                    <TableCell>CCQ</TableCell>
                                    <TableCell>IP</TableCell>
                                </TableRow>
                                </TableHead>
                                <TableBody>
                                {informacionAPCPE.map((row, index) => (
                                    <TableRow key={`cpe_Info_${index}`}>
                                        <TableCell > {row.radioName}</TableCell>
                                        <TableCell >{row.macAddress}</TableCell>
                                        <TableCell >{row.lastActivity}</TableCell>
                                        <TableCell >{`tx:${row.txCcq} rx:${row.rxCcq}`}</TableCell>
                                        <TableCell >{row.lastIp}</TableCell>
                                    </TableRow>
                                ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </DialogContent>
            </Dialog>
            <ModalAntd title="INFORMACION CONEXION" visible={getOpenStatusCPE} onCancel={handleCloseInfoCPE} okButtonProps={{disabled:true, type:'ghost'}}>
                <Paper variant="outlined" square style={{padding:10, width:'100%'}} >
                    <Grid container justifyContent='space-between' spacing={2}> 
                        <Grid item xs={12}>
                            <Grid container justifyContent='space-around' spacing={1}>  
                                <Grid item xs={6}>
                                    <TextField 
                                        id='APCPE'
                                        fullWidth
                                        label='AP'
                                        value={getInfoCPE['radio-name'] || ''}
                                        variant='outlined'
                                        size='large'
                                        margin='dense'
                                    />
                                </Grid>                 
                                <Grid item xs={6}>
                                    <TextField 
                                        id='UPTIME'
                                        fullWidth
                                        label='TIEMPO ONLINE'
                                        value={getInfoCPE['uptime'] || ''}
                                        variant='outlined'
                                        size='large'
                                        margin='dense'
                                    />
                                </Grid>                            
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container justifyContent='space-around' spacing={1}>                   
                                <Grid item xs={6}>
                                    <TextField 
                                        id='CCQTX'
                                        fullWidth
                                        label='CCQ TX'
                                        value={getInfoCPE['tx-ccq'] || ''}
                                        variant='outlined'
                                        size='large'
                                        margin='dense'
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField 
                                        id='CCQRX'
                                        fullWidth
                                        label='CCQ RX'
                                        value={getInfoCPE['rx-ccq'] || ''}
                                        variant='outlined'
                                        size='large'
                                        margin='dense'
                                    />
                                </Grid>                             
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container justifyContent='space-around' spacing={1}>                   
                                <Grid item xs={6}>
                                    <TextField 
                                        id='TXSIGNAL'
                                        fullWidth
                                        label='SIGNAL TX'
                                        value={getInfoCPE['tx-signal-strength'] || ''}
                                        variant='outlined'
                                        size='large'
                                        margin='dense'
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField 
                                        id='RXSIGNAL'
                                        fullWidth
                                        label='SIGNAL RX'
                                        value={getInfoCPE['signal-strength'] || ''}
                                        variant='outlined'
                                        size='large'
                                        margin='dense'
                                    />
                                </Grid>                               
                            </Grid>
                        </Grid>
                        
                    </Grid>
                </Paper>
            </ModalAntd>
            <ModalAntd title="INFORMACION INTERFACES" visible={getOpenInterfaces} onCancel={handleCloseInterfaces} okButtonProps={{disabled:true, type:'ghost'}}>
                <Paper variant="outlined" square style={{padding:10, width:'100%'}} >
                    <Grid container justifyContent='space-between' spacing={2}> 
                        <Grid item xs={6}>
                            <TextField 
                                id='STATUSCPEROUTER'
                                fullWidth
                                label='AP'
                                value={getInterfaces.Status || ''}
                                variant='outlined'
                                size='large'
                                margin='dense'
                            />
                        </Grid>                 
                        <Grid item xs={6}>
                            <TextField 
                                id='LASTUPTIME'
                                fullWidth
                                label='ULTIMA DESCONEXION'
                                value={getInterfaces.UltimaDesconexion || ''}
                                variant='outlined'
                                size='large'
                                margin='dense'
                            />
                        </Grid>      
                        <Grid item xs={6}>
                            <TextField 
                                id='MACWLAN'
                                fullWidth
                                label='MAC WLAN'
                                value={getInterfaces.MacWlan || ''}
                                variant='outlined'
                                size='large'
                                margin='dense'
                                InputProps={{ 
                                    endAdornment:
                                    <IconButton size='small' onClick={copyMacWlan} color='primary'>
                                        <ContentCopyIcon/>
                                    </IconButton>
                                }} 
                            />
                        </Grid>    
                        <Grid item xs={6}>
                            <TextField 
                                id='MACLAN'
                                fullWidth
                                label='MAC LAN'
                                value={getInterfaces.MacLan || ''}
                                variant='outlined'
                                size='large'
                                margin='dense'
                                InputProps={{ 
                                    endAdornment:
                                    <IconButton size='small' onClick={copyMacLan} color='primary'>
                                        <ContentCopyIcon/>
                                    </IconButton>
                                }} 
                            />
                        </Grid>                                    
                        <Grid item xs={6}>
                            <TextField 
                                id='MACROUTER'
                                fullWidth
                                label='MAC ROUTER'
                                value={getInterfaces.MacRouter || ''}
                                variant='outlined'
                                size='large'
                                margin='dense'
                                InputProps={{ 
                                    endAdornment:
                                    <IconButton size='small' onClick={copyMacRouter} color='primary'>
                                        <ContentCopyIcon/>
                                    </IconButton>
                                }} 
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField 
                                id='ISSTATIC'
                                fullWidth
                                label='ES ESTATICO'
                                value={getInterfaces.isStatic || ''}
                                variant='outlined'
                                size='large'
                                margin='dense'
                            />
                        </Grid>                             
                    </Grid>
                </Paper>
            </ModalAntd> 
            <ModalAntd title="COMANDOS MIKROTIK" visible={getOpenComandos} onCancel={handleCloseComandos} okButtonProps={{disabled:true, type:'ghost'}}>
                <Paper variant="outlined" square style={{padding:10, width:'100%'}} >
                    <Grid container justifyContent='space-between' spacing={2}> 
                        <Grid item xs={6} style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                            <TooltipAntd title="DST PORT 8880" color='purple' placement='right'>
                                <ButtonAntd style={{backgroundColor:'teal'}} type="primary" icon={isDstPort ? <LoadingOutlinedIcon/> : <RadiusSettingOutlinedIcon />} size='large' onClick={handleDstPort8880}/>
                            </TooltipAntd>
                        </Grid>                 
                        <Grid item xs={6} style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                            <TooltipAntd title="REMOVER ARP" color='purple' placement='left'>
                                <ButtonAntd style={{backgroundColor:'blue'}} type="primary" icon={isRemovingArp ? <LoadingOutlinedIcon/> : <DeleteOutlinedIcon />} size='large' onClick={handleRemoveArp}/>
                            </TooltipAntd>
                        </Grid>                                          
                        <Grid item xs={6} style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                            <TooltipAntd title="ESTABLECER PASS" color='purple' placement='right'>
                                <ButtonAntd style={{backgroundColor:'green'}} type="primary" icon={getPassCPE ? <LoadingOutlinedIcon/> : <VerifiedOutlinedIcon />} size='large' onClick={handlePassCPE}/>
                            </TooltipAntd>
                        </Grid>                 
                        <Grid item xs={6} style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                            <TooltipAntd title="ESTABLECER WLAN" color='purple' placement='left'>
                                <ButtonAntd style={{backgroundColor:'navy'}} type="primary" icon={getInfoWlan ? <LoadingOutlinedIcon/> : <InteractionOutlinedIcon />} size='large' onClick={handleInfoWlan}/>
                            </TooltipAntd>
                        </Grid>
                        <Grid item xs={6} style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                            <TooltipAntd title="CONFIGURAR MIKROTIK NUEVO" color='purple' placement='right'>
                                <Popconfirm
                                    title="Desea Continuar?"
                                    onConfirm={handleSyncMikrotikNew}
                                    okText="SI"
                                    cancelText="NO"
                                >
                                    <ButtonAntd style={{backgroundColor:'orange'}} shape='circle' type="primary" icon={isRebootCPE ? <LoadingOutlinedIcon /> : <SyncIcon />} size='large' />
                                </Popconfirm>
                            </TooltipAntd>                     
                        </Grid> 
                        <Grid item xs={6} style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                            <TooltipAntd title="CONFIGURAR MIKROTIK" color='purple' placement='left'>
                                <Popconfirm
                                    title="Desea Continuar?"
                                    onConfirm={handleSyncMikrotik}
                                    okText="SI"
                                    cancelText="NO"
                                >
                                    <ButtonAntd style={{backgroundColor:'green'}} shape='circle' type="primary" icon={isRebootCPE ? <LoadingOutlinedIcon /> : <SyncIcon />} size='large' />
                                </Popconfirm>
                            </TooltipAntd>                     
                        </Grid>                             
                    </Grid>
                </Paper>
            </ModalAntd> 
            <Paper elevation={3} style={{padding:5}} key={`servicio${index}`}>
                <Grid container  spacing={2} >
                    <Grid item xs={12} style={{display:'flex', flexDirection:'row', justifyContent:'center'}}>
                        <Grid container spacing={2} justifyContent='center'>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center', height:42, alignText:'center',}}>
                                {
                                    data.Status === 'Activo' ?
                                        <TooltipAntd title="SERVICIO ACTIVO" color='green'>
                                            <CheckCircleIcon style={{color:'green', marginTop:15}} fontSize='large'/>
                                        </TooltipAntd>
                                        :
                                        <TooltipAntd title="SERVICIO SUSPENDIDO" color='red'>
                                            <BlockIcon style={{color:'red', marginTop:15}} fontSize='large'/>
                                        </TooltipAntd>
                                }                                       
                            </Grid>
                        
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="VERIFICAR CPE EN AP" color='purple'>
                                    <ButtonAntd style={{backgroundColor:'orange'}} type="primary" icon={isInfoCharging ? <LoadingOutlinedIcon/> : <ApiOutlinedIcon />} size='large' onClick={handleVerificarCPE}/>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="STATUS CPE" color='purple'>
                                    <ButtonAntd style={{backgroundColor:'brown'}} type="primary" icon={isInfoCharging2 ? <LoadingOutlinedIcon/> : <WifiOutlinedIcon />} size='large' onClick={handleStatusCPE}/>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="INTERFACES CPE" color='purple'>
                                    <ButtonAntd style={{backgroundColor:'green'}} type="primary" icon={isInterfacesCharging ? <LoadingOutlinedIcon/> : <ClusterOutlinedIcon />} size='large' onClick={handleInterfaces} />
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="COMANDOS CPE" color='purple'>
                                    <ButtonAntd style={{backgroundColor:'navy'}} type="primary" icon={<SettingOutlinedIcon />} size='large' onClick={handleOpenComandos} />
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="REINICIAR CPE" color='purple' placement='right'>
                                    <Popconfirm
                                        title="DESEA REINICIAR EL CPE?"
                                        onConfirm={handleRebootCPE}
                                        okText="SI"
                                        cancelText="NO"
                                    >
                                        <ButtonAntd style={{backgroundColor:'orange'}} shape='circle' type="primary" icon={isRebootCPE ? <LoadingOutlinedIcon /> : <PoweroffOutlinedIcon />} size='large' />
                                    </Popconfirm>
                                </TooltipAntd>
                            </Grid>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="CREAR PDF" color='purple'>
                                    <ButtonAntd type="danger" icon={<FilePdfOutlinedIcon />} size='large' onClick={handleCreatePdf}/>
                                </TooltipAntd>
                            </Grid>
                            <Grid item >
                                {
                                    data.TipoServicio === 'Fibra Optica' ? 
                                    <Fragment>
                                        {isReadyPdf && <PdfInstalacionFibra data={data} handleClickPdf={handleClickPdf} dataCliente={dataCliente}/>}
                                    </Fragment> : 
                                    <Fragment>
                                        {isReadyPdf && <PdfInstalacionRadio data={data} handleClickPdf={handleClickPdf} dataCliente={dataCliente}/>}
                                    </Fragment>
                                }
                            </Grid>  
                        </Grid>                                  
                    </Grid>
                    <Grid item xs ={12} style={{height:300}}>
                        < div
                            ref={ mapDiv }
                            style={{width:'100%', height:'100%'}}
                        />
                    </Grid>
                    <Grid item md={6} xs={12} >
                        <TextField 
                            id='idForMikrotik'
                            fullWidth
                            label='idMikrotik'
                            value={data.idForMikrotik || ''}
                            variant='outlined'
                            size='small'
                            margin='dense'
                            InputProps={{ 
                                startAdornment: <WhatshotIcon/>,
                                endAdornment:
                                <IconButton size='small' onClick={copyToClipBoardUser} color='primary'>
                                    <ContentCopyIcon/>
                                </IconButton>
                            }} 
                        />
                    </Grid>
                    <Grid item md={6} xs={12} >
                        <TextField 
                            id='Plan' 
                            fullWidth
                            label='Plan'
                            value={data.Plan || ''}   
                            variant='outlined'
                            size='small'
                            margin='dense'
                        />
                    </Grid>
                    <Grid item xs={12} >
                        <TextField 
                            id='Direccion'
                            fullWidth
                            label='Direccion'
                            value={data.Direccion || ''}
                            InputProps={{ startAdornment: <PlaceIcon/>  }}
                            variant='outlined'
                            multiline
                            rows={2}
                        />
                    </Grid>    
                    <Grid item xs={12} >
                        <TextField 
                            id='Referencia'
                            fullWidth
                            label='Referencia'
                            value={data.Referencia || ''}
                            variant='outlined'
                            multiline
                            InputProps={{
                                startAdornment: <PlaceIcon/>,
                                endAdornment: 
                                <IconButton aria-label="search" onClick={handleOpenPhoto} size='medium'>
                                    <PhotoIcon color='primary' />
                                </IconButton>
                            }}
                        />
                    </Grid>  
                    <Grid item md={6} xs={12} >
                        <TextField 
                            id='Coordenadas'
                            fullWidth
                            label='Coordenadas'
                            value={DatosD.Coordenadas || ''}
                            variant='outlined'
                            InputProps={{
                                endAdornment: 
                                <IconButton aria-label="search" onClick={handleCoordenadas} size='medium'>
                                    <GpsFixedIcon color='primary' />
                                </IconButton>
                            }}
                        />
                    </Grid>
                    <Grid item md={6} xs={12} >
                        <Grid container justifyContent='center' spacing={1}>
                            <Grid item style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                <TooltipAntd title="INFORMACION CPE" color='purple'>
                                    <ButtonAntd type="primary" icon={isInfoCharging ? <LoadingOutlinedIcon/> : <WifiOutlinedIcon />} size='large' onClick={handleInformacionCPE}/>
                                </TooltipAntd>
                            </Grid>
                            <Grid item xs={10}>
                                <TextField 
                                    id='AP' 
                                    fullWidth
                                    label='AP'
                                    value={data.AP || ''}   
                                    variant='outlined'
                                    size='small'
                                    margin='dense'
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item md={6} xs={12} >
                        <TextField 
                            id='Modelo' 
                            fullWidth
                            label='CPE'
                            value={data.Modelo || ''}   
                            variant='outlined'
                            size='small'
                            margin='dense'
                        />
                    </Grid>
                    <Grid item md={6} xs={12} >
                        <TextField 
                            id='MacModelo' 
                            fullWidth
                            label='MacCPE'
                            value={data.MacModelo || ''}   
                            variant='outlined'
                            size='small'
                            margin='dense'
                        />
                    </Grid>            
                    <Grid item md={6} xs={12} >
                        <TextField 
                            id='Router' 
                            fullWidth
                            label='Router'
                            value={data.Router || ''}   
                            variant='outlined'
                            size='small'
                            margin='dense'
                        />
                    </Grid>
                    <Grid item md={6} xs={12} >
                        <TextField 
                            id='MacRouter' 
                            fullWidth
                            label='MacRouter'
                            value={data.MacRouter || ''}   
                            variant='outlined'
                            size='small'
                            margin='dense'
                        />
                    </Grid>
                    <Grid item md={6} xs={12} >
                        <TextField 
                            id='Subnet' 
                            fullWidth
                            label='Subnet'
                            value={data.Red || ''}   
                            variant='outlined'
                            size='small'
                            margin='dense'
                        />
                    </Grid>
                    <Grid item md={6} xs={12} >
                        <TextField 
                            id='AddressIp' 
                            fullWidth
                            label='AddressIp'
                            value={data.AddressIp || ''}   
                            variant='outlined'
                            size='small'
                            margin='dense'
                        />
                    </Grid>      
                    {
                        zonaSelected.ppoeList &&
                        <Fragment>
                            <Grid item md={6} xs={12} >
                                <TextField 
                                    id='UserPPOE'
                                    fullWidth
                                    label='UserPPOE'
                                    value={data.UserPPOE || ''}
                                    InputProps={{
                                        startAdornment:<DnsIcon/>
                                    }}
                                    variant='outlined'
                                    size='small'
                                    margin='dense'
                                />
                            </Grid>
                            <Grid item md={6} xs={12} >
                                <TextField 
                                    id='PassPPOE'
                                    fullWidth
                                    label='PassPPOE'
                                    value={data.PassPPOE || ''}
                                    InputProps={{
                                        startAdornment:<DnsIcon/>
                                    }}
                                    variant='outlined'
                                    size='small'
                                    margin='dense'
                                />
                            </Grid>
                        </Fragment>
                    }           
                    <Grid item md={6} xs={12} >
                        <TextField 
                            id='UserMk'
                            fullWidth
                            label='UserMk'
                            value={data.UserMk || ''}
                            variant='outlined'
                            size='small'
                            margin='dense'
                        />
                    </Grid>
                    <Grid item md={6} xs={12} >
                        <TextField 
                            id='PassMk'
                            fullWidth
                            label='PassMk'
                            value={data.PassMk || ''}  
                            variant='outlined'
                            margin='dense'
                            size='small'
                        />
                    </Grid>
                    <Grid item md={6} xs={12} >
                        <TextField 
                            id='ValorInstalacion'
                            fullWidth
                            label='ValorInstalacion'
                            value={data.ValorInstalacion}
                            InputProps={{ startAdornment:<MonetizationOnIcon/> }}     
                            variant='outlined'
                            size='small'
                            margin='dense'
                            type='Number'
                        />    
                    </Grid>
                    <Grid item md={6} xs={12} > 
                        <TextField 
                            id='Instalacion'
                            fullWidth
                            label='Instalacion'
                            value={data.Instalacion || ''}
                            InputProps={{ startAdornment:<DnsIcon/>}}
                            variant='outlined'
                            size='small'
                            margin='dense'
                            type='date'
                        />                     
                    </Grid>
                    <Grid item md={6} xs={12} > 
                        <TextField 
                            id='HoraInstalacion'
                            fullWidth
                            label='HoraInstalacion'
                            value={data.HoraInstalacion || ''}
                            InputProps={{ startAdornment:<DnsIcon/> }}
                            variant='outlined'
                            size='small'
                            margin='dense'
                            type='time'
                        />                     
                    </Grid>
                    <Grid item md={6} xs={12} >
                        <TextField 
                            id='NameWifi'
                            fullWidth
                            label='NameWifi'
                            value={data.NameWifi || ''}                          
                            variant='outlined'
                            size='small'
                            margin='dense'
                        />
                    </Grid>
                    <Grid item md={6} xs={12} >
                        <TextField 
                            id='PassWifi'
                            fullWidth
                            label='PassWifi'
                            value={data.PassWifi || ''}                        
                            variant='outlined'
                            size='small'
                            margin='dense'
                        />
                    </Grid>
                    <Grid item md={6} xs={12} >
                        <TextField 
                            id='Comentario'
                            fullWidth
                            label='Comentario'
                            value={data.Comentario || ''}                        
                            variant='outlined'
                            size='small'
                            margin='dense'
                        />
                    </Grid>
                </Grid>
            </Paper>
        </Grid>
    )
});

const UploadElementYouNET = ({classes, info, handleUpdatePhoto, idForMikrotik, handleDeletePhoto, idServicio, idCliente, getArrPhotos})=>{
    const { enqueueSnackbar } = useSnackbar();
    const [ photoReport, setPhotoReport ] = useState();
    const [ photoReportPreview, setPhotoReportPreview ] = useState('');
    const [ showElement, setShowElement ]= useState(false);
    const [ isSelectElement, setElementSelect ] =useState (false);
    const [ openPhotos, setOpenPhotos ] = useState(false);
    const [ modePhoto, setModePhoto ] = useState(false);
    const [ continuoPhoto, setContinuoPhoto ] = useState(false);
    const [ getUpImage, setUpImage ] = useState(false);

    useEffect(()=>{
        if(info.src !== ''){
            if(info.src.length > 0){
                setModePhoto(true);
            }
        }
    },[]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(()=>{
        if(showElement)setShowElement(false);
    },[showElement]);

    useEffect(()=>{
        if(continuoPhoto){
            setContinuoPhoto(false);
            setModePhoto(true);
        }
    },[continuoPhoto]);

    const handleSubmitPhotoReport = (e)=> { 
        setUpImage(true);
        e.preventDefault();
        let name = uuidv4();
        const nombreImagen = `${idForMikrotik}_${name}.${photoReport.name.split('.').pop().toString()}`;
        let formD = new FormData();
        formD.append('imagen',photoReport, nombreImagen);
        fetch('/Servicios/FotosReferencia',{method:'POST',body:formD})
        .then(response => response.json())
        .then(result => {             
            if(result.message){
                const objeto = {...info};
                objeto.src = `/fotosRef/${nombreImagen}`;
                const arr_ = getArrPhotos.map(el=>{
                    if(el.id === info.id){
                        return objeto
                    }else{
                        return el
                    }
                })             
                const objeto2 = {};
                objeto2.idCliente = idCliente;
                objeto2.idServicio = idServicio;
                objeto2.FotosArr = arr_;
                fetch('/api/clientes/serviciosFotos',{
                    method:'PUT',
                    body: JSON.stringify(objeto2),
                    headers:{
                        'Content-Type': 'application/json'
                    }
                }) 
                .then(response=> response.json())
                .then(result2 =>{
                    if(result2.message){
                        enqueueSnackbar(result2.message, {variant:'success'});
                        handleUpdatePhoto(arr_); 
                        setContinuoPhoto(true);
                        setUpImage(false);
                    }else{
                        enqueueSnackbar(result.status, {variant:'error'});
                        setUpImage(false);
                    }
                })
            }else{
                enqueueSnackbar(result.status, {variant:'error'})
                setUpImage(false);
            }
        });
    };

    const handleImageChangeReport = (e)=>{
        
        e.preventDefault();
    
        let reader = new FileReader();
        let file = e.target.files[0];
    
        reader.onloadend = () => {
            setPhotoReport(file);
            setPhotoReportPreview(reader.result);
            setElementSelect(true);
        }
    
        reader.readAsDataURL(file)
    };

    const handleDeleteImage = ()=>{
        if(modePhoto){
            const conf = window.confirm('SE ELIMINARA ESTA IMAGEN DE LA BASE DE DATOS');
            if(conf){
                const nameImage = info.src.split('/').pop().toString();
                fetch('/Servicios/FotosReferencia',{
                    method: 'DELETE',
                    body: JSON.stringify({nameImage}),
                    headers:{
                      'Content-Type':'application/json'
                    }
                })
                .then(response => response.json())
                .then(result => {             
                    if(result.message){
                        const arr_ = getArrPhotos.filter(el=> el.id !== info.id);
                        const objeto = {};
                        objeto.idCliente = idCliente;
                        objeto.idServicio = idServicio;
                        objeto.FotosArr = arr_;
                        fetch('/api/clientes/serviciosFotos',{
                            method:'PUT',
                            body: JSON.stringify(objeto),
                            headers:{
                                'Content-Type': 'application/json'
                            }
                        }) 
                        .then(response=> response.json())
                        .then(result2 =>{
                            if(result2.message){
                                enqueueSnackbar(result2.message, {variant:'success'});
                                handleUpdatePhoto(arr_); 
                                setModePhoto(false);
                            }else{
                                enqueueSnackbar(result.status, {variant:'error'});
                            }
                        })
                    }else{
                        enqueueSnackbar(result.status, {variant:'error'});
                    }
                });
            }
        }else{
            setPhotoReport();
            setPhotoReportPreview('');
            setShowElement(true);
            setElementSelect(false);
            handleDeletePhoto(info);
        }
        
    };

    const HandleClosePhotos = ()=>{ setOpenPhotos(false);};

    const HandleShowPhotos = ()=>{
        if(modePhoto){
            setOpenPhotos(true);
        }else{
            if(photoReportPreview === ''){
                alert('NO HAY FOTOS')
             }else{
                 setOpenPhotos(true);
             }
        }
        
    };

    return(
        <Grid container className={classes.containerUpload} justifyContent='center'>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <Viewer
                    visible={openPhotos}
                    onClose={HandleClosePhotos}
                    images={[{src:modePhoto ? info.src : photoReportPreview, alt:''}]}
                    zIndex={2000}
                />
                <Paper square className={classes.paper}>
                    <Grid container justifyContent='center' spacing={1}>
                        <Grid item xl={12} lg={12} md={12} sm={12} xs={12} style={{display:'flex', justifyContent:'center', height:50}}>
                            <Grid container justifyContent='flex-end'>
                                <Grid item xs={10}>
                                {
                                    !showElement &&
                                    <input 
                                        type="file" 
                                        onChange={handleImageChangeReport} 
                                        className={classes.inputUp}
                                        disabled={modePhoto}
                                    />
                                }
                                </Grid>
                                <Grid item xs={2} style={{display:'flex', justifyContent:'center', alignItems:'center', alignContent:'center'}}>
                                    <IconButton onClick={handleDeleteImage} size='medium'>
                                        <DeleteForeverIcon style={{color:'red'}}/>
                                    </IconButton>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                            <Card className={classes.rootCard}>
                                <CardHeader
                                    title={<Chip color='primary' icon={isSelectElement ? <DoneIcon /> : <HelpIcon/>} label='foto_Referencia' style={{textOverflow:'ellipsis', overflow:'none', width:200}}/> }
                                />
                                <Fragment>
                                    {
                                        modePhoto ?
                                        <CardMedia
                                            className={classes.media}
                                            image={info.src}
                                            title='foto_Referencia'
                                            onClick={HandleShowPhotos}
                                        />:
                                        <Fragment>
                                            {photoReportPreview !== '' &&
                                                <CardMedia
                                                    className={classes.media}
                                                    image={photoReportPreview}
                                                    title={photoReportPreview === '' ? '' :photoReport.name}
                                                    onClick={HandleShowPhotos}
                                                />
                                            }
                                        </Fragment>
                                    }
                                </Fragment>
                                
                            </Card>
                        </Grid>
                        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                                <Button variant="contained" fullWidth size="large" color="primary" startIcon={getUpImage ?<LoadingOutlinedIcon/> : <CloudUploadIcon/>} disabled={!isSelectElement} onClick={handleSubmitPhotoReport}>
                                    SUBIR
                                </Button>
                            </Grid>
                    </Grid>      
                </Paper>
            </Grid>
        </Grid>
    );
};


function ClientAdd(){
    return (
        <SnackbarProvider maxSnack={3} hideIconVariant={false} dense >
            <YounetClientAdd />
        </SnackbarProvider>
    );
};

export default ClientAdd;